import { useEffect } from 'react';

import { useImpState } from '../../app/hooks';
import { clearHomePageState } from '../../utils/functionUtils';
import { PAGE } from '../../utils/routeConstant';
import styles from './ErrorModal.module.css';

interface ErrorModalProps {
  title: string;
  subline: string;
}

export default function ErrorModal({ title, subline }: ErrorModalProps) {
  const { language, dispatch, navigate } = useImpState();
  if (language == null) {
    return <></>;
  }

  // ! disabling this is bad (hooks should not be called conditionally)
  // ! but this page is important and I don't want to break anything rn for the sake of linting
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    window.onpopstate = () => {
      clearHomePageState(dispatch);
      navigate(PAGE.HOME);
    };
  });

  return (
    <div className={styles.container}>
      <h1>{title}</h1>
      <p>{subline}</p>
      <div className={styles.errorContact}>
        {language.errorContact}
        <a href={'mailto:support@imprint.co'} tabIndex={0}>
          support@imprint.co
        </a>
        .
      </div>
    </div>
  );
}
